import t from "@/lang/lang";
import { TableColumn } from "../position/components/positions-component";
import { PositionsTableConfig } from "../position/components/positions-table";
import { Position } from "../position/types/position";
import { PositionKind } from "../position/types/position-kind";
import {
  offerablePositionBaseData,
  PositionOptions,
} from "../position/types/position-base-data";
import { omniPricesUsed } from "./omni-prices-used";

/**
 * omniPositionsTableConfig returns the configuration of a
 * {@link PositionsTable} of omni positions: groups and areas group them,
 * and each option is offered where its availableIn says.
 */
export function omniPositionsTableConfig(
  positions: Position[],
  options: PositionOptions,
): PositionsTableConfig {
  return {
    groupName: t("Gruppe"),
    areaName: t("Bereich"),
    addPositionOptions: offerablePositionBaseData(positions, options),
    groupings: ["group", "area"],
    subPositionKinds: [PositionKind.Text],
    editableNumbers: true,
    pricesUsed: omniPricesUsed,
    tableColumns: [
      TableColumn.DnDGrip,
      TableColumn.Number,
      TableColumn.Active,
      TableColumn.ProductNumber,
      TableColumn.TextShort,
      TableColumn.Text,
      TableColumn.Cycle,
      TableColumn.ServiceObject,
      TableColumn.Category,
      TableColumn.Hours,
      TableColumn.HoursRate,
      TableColumn.Count,
      TableColumn.Unit,
      TableColumn.UnitPrice,
      TableColumn.FinalPrice,
      TableColumn.SubscriptionInterval,
      TableColumn.SubscriptionPrice,
      TableColumn.Actions,
    ],
  };
}
